
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-11827a19\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./solicitacaoDetalhes.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./solicitacaoDetalhes.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-11827a19\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./solicitacaoDetalhes.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/atendimentos/comuns/solicitacaoDetalhes.vue
// module id = 253
// module chunks = 0